import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = ({ isToday }: { isToday: boolean }) =>
  makeStyles((theme: Theme) => ({
    wrapperEmptyCard: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: `${theme.spacing(0.625)} ${theme.spacing(1.25)}`,
      border: "1px solid #ECECEC",
      borderRadius: theme.spacing(0.875),
      fontFamily: "SFProText-Bold",
    },
    wrapperDay: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      width: "fit-content",
      fontWeight: "bold",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: theme.spacing(1.25),
      backgroundColor: isToday ? "#000" : "#f9f9f9",
      fontFamily: "SFProText-Bold",
      borderRadius: theme.spacing(1),
    },
    day: {
      display: "flex",
      flexDirection: "column",
      // alignItems: "center",
      fontSize: "13px",
      color: "#a0a0a0",
    },
    numDay: {
      color: "black",
      fontSize: "20px",
    },
    button: {
      color: "#A2A2A2",
      marginLeft: theme.spacing(1.25),
      "& span": {
        fontSize: "14px",
        textTransform: "uppercase",
      },
    },
    popoverWorkout: {
      "& div[class~='ant-popover-inner-content']": {
        borderRadius: theme.spacing(0.875),
        padding: "0 !important",
        overflow: "hidden",
      },
    },
    popoverContent: {
      borderRadius: theme.spacing(0.875),
      padding: 0,
      overflow: "hidden",
    },
  }));

export default useStyles;
